import { appQueryClient } from '@libs/data-access/queries'

export const shiftApiCacheKeys = {
  get: (pathParams = {}) => ['shift', pathParams],
  all: () => ['shift']
}

export const shiftInvalidations = {
  invalidateShift: (pathParams = {}) =>
    appQueryClient.invalidateQueries({
      queryKey: shiftApiCacheKeys.get(pathParams)
    })
}
